module.exports = __webpack_public_path__ + "img/sms.0ccfb96a.svg";